var ignoreStoreSelector=false;

var ua=''+navigator.userAgent;
if (ua.indexOf('APIs-Google')<0 && ua.indexOf('Mediapartners-Google')<0 && ua.indexOf('AdsBot-Google-Mobile')<0 && ua.indexOf('AdsBot-Google')<0 &&
    ua.indexOf('Googlebot-')<0 && ua.indexOf('Googlebot/')<0 && ua.indexOf('AdsBot-Google-Mobile-Apps')<0 && ua.indexOf('bing.com/bingbot')<0 &&
    ua.indexOf('deepcrawl.com/bot')<0 && ua.indexOf('BingBot (')<0 && ua.indexOf('Baiduspider/')<0 && ua.indexOf('Pinterest/')<0 && ua.indexOf('Google Favicon')<0 &&
    ua.indexOf('DuckDuckGo')<0 && ua.indexOf('Yahoo! Slurp')<0 && ua.indexOf('MJ12bot')<0 && ua.indexOf('proximic.com/')<0 && ua.indexOf('Sogou web spider')<0 &&
    ua.indexOf('Slackbot-LinkExpanding')<0 && ua.indexOf('YandexBot/')<0 && ua.indexOf('AhrefsBot/')<0 && ua.indexOf('Twitterbot/')<0 && ua.indexOf('google.com/+/web/snippet')<0 &&
    ua.indexOf('BingPreview/')<0 && ua.indexOf('360Spider(')<0 && ua.indexOf('YodaoBot/')<0 && ua.indexOf('msnbot/')<0 && ua.indexOf('Sosospider+')<0 &&
    ua.indexOf('facebookexternalhit/')<0 && ua.indexOf('Facebot')<0) {
    saveCountry();
    $(document).ready(function() {
        setTimeout(updateStoreSelector, 1000);
    });
}

function saveCountry() {
    if (!$.cookie('slCCodes') || !$.cookie('slUserIP')) {
        $.getJSON('https://api.ipstack.com/check?access_key=1013a0e5619c2054a66ac712aba870c8&legacy=1', function(data){
            console.log('data = ',data);
            var stores = {
                "AF": {
                    "Name": "Afghanistan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AX": {
                    "Name": "Aland Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AL": {
                    "Name": "Albania",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DZ": {
                    "Name": "Algeria",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AS": {
                    "Name": "American Samoa",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AD": {
                    "Name": "Andorra",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AO": {
                    "Name": "Angola",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AI": {
                    "Name": "Anguilla",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AQ": {
                    "Name": "Antarctica",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AG": {
                    "Name": "Antigua And Barbuda",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AR": {
                    "Name": "Argentina",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AM": {
                    "Name": "Armenia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AW": {
                    "Name": "Aruba",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AU": {
                    "Name": "Australia",
                    "Store": "https:\/\/aus.moanabikini.com"
                },
                "AT": {
                    "Name": "Austria",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AZ": {
                    "Name": "Azerbaijan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BS": {
                    "Name": "Bahamas",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BH": {
                    "Name": "Bahrain",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BD": {
                    "Name": "Bangladesh",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BB": {
                    "Name": "Barbados",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BY": {
                    "Name": "Belarus",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BE": {
                    "Name": "Belgium",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BZ": {
                    "Name": "Belize",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BJ": {
                    "Name": "Benin",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BM": {
                    "Name": "Bermuda",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BT": {
                    "Name": "Bhutan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BO": {
                    "Name": "Bolivia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BA": {
                    "Name": "Bosnia And Herzegovina",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BW": {
                    "Name": "Botswana",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BV": {
                    "Name": "Bouvet Island",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BR": {
                    "Name": "Brazil",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IO": {
                    "Name": "British Indian Ocean Territory",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BN": {
                    "Name": "Brunei Darussalam",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BG": {
                    "Name": "Bulgaria",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BF": {
                    "Name": "Burkina Faso",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BI": {
                    "Name": "Burundi",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KH": {
                    "Name": "Cambodia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CM": {
                    "Name": "Cameroon",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CA": {
                    "Name": "Canada",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CV": {
                    "Name": "Cape Verde",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KY": {
                    "Name": "Cayman Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CF": {
                    "Name": "Central African Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TD": {
                    "Name": "Chad",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CL": {
                    "Name": "Chile",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CN": {
                    "Name": "China",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CX": {
                    "Name": "Christmas Island",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CC": {
                    "Name": "Cocos (Keeling) Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CO": {
                    "Name": "Colombia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KM": {
                    "Name": "Comoros",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CG": {
                    "Name": "Congo",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CD": {
                    "Name": "Congo, Democratic Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CK": {
                    "Name": "Cook Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CR": {
                    "Name": "Costa Rica",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CI": {
                    "Name": "Cote D'Ivoire",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HR": {
                    "Name": "Croatia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CU": {
                    "Name": "Cuba",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CY": {
                    "Name": "Cyprus",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CZ": {
                    "Name": "Czech Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DK": {
                    "Name": "Denmark",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DJ": {
                    "Name": "Djibouti",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DM": {
                    "Name": "Dominica",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DO": {
                    "Name": "Dominican Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "EC": {
                    "Name": "Ecuador",
                    "Store": "https:\/\/moanabikini.com"
                },
                "EG": {
                    "Name": "Egypt",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SV": {
                    "Name": "El Salvador",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GQ": {
                    "Name": "Equatorial Guinea",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ER": {
                    "Name": "Eritrea",
                    "Store": "https:\/\/moanabikini.com"
                },
                "EE": {
                    "Name": "Estonia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ET": {
                    "Name": "Ethiopia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FK": {
                    "Name": "Falkland Islands (Malvinas)",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FO": {
                    "Name": "Faroe Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FJ": {
                    "Name": "Fiji",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FI": {
                    "Name": "Finland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FR": {
                    "Name": "France",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GF": {
                    "Name": "French Guiana",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PF": {
                    "Name": "French Polynesia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TF": {
                    "Name": "French Southern Territories",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GA": {
                    "Name": "Gabon",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GM": {
                    "Name": "Gambia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GE": {
                    "Name": "Georgia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "DE": {
                    "Name": "Germany",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GH": {
                    "Name": "Ghana",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GI": {
                    "Name": "Gibraltar",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GR": {
                    "Name": "Greece",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GL": {
                    "Name": "Greenland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GD": {
                    "Name": "Grenada",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GP": {
                    "Name": "Guadeloupe",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GU": {
                    "Name": "Guam",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GT": {
                    "Name": "Guatemala",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GG": {
                    "Name": "Guernsey",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GN": {
                    "Name": "Guinea",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GW": {
                    "Name": "Guinea-Bissau",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GY": {
                    "Name": "Guyana",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HT": {
                    "Name": "Haiti",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HM": {
                    "Name": "Heard Island & Mcdonald Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VA": {
                    "Name": "Holy See (Vatican City State)",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HN": {
                    "Name": "Honduras",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HK": {
                    "Name": "Hong Kong",
                    "Store": "https:\/\/moanabikini.com"
                },
                "HU": {
                    "Name": "Hungary",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IS": {
                    "Name": "Iceland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IN": {
                    "Name": "India",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ID": {
                    "Name": "Indonesia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IR": {
                    "Name": "Iran, Islamic Republic Of",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IQ": {
                    "Name": "Iraq",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IE": {
                    "Name": "Ireland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IM": {
                    "Name": "Isle Of Man",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IL": {
                    "Name": "Israel",
                    "Store": "https:\/\/moanabikini.com"
                },
                "IT": {
                    "Name": "Italy",
                    "Store": "https:\/\/moanabikini.com"
                },
                "JM": {
                    "Name": "Jamaica",
                    "Store": "https:\/\/moanabikini.com"
                },
                "JP": {
                    "Name": "Japan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "JE": {
                    "Name": "Jersey",
                    "Store": "https:\/\/moanabikini.com"
                },
                "JO": {
                    "Name": "Jordan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KZ": {
                    "Name": "Kazakhstan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KE": {
                    "Name": "Kenya",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KI": {
                    "Name": "Kiribati",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KR": {
                    "Name": "Korea",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KW": {
                    "Name": "Kuwait",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KG": {
                    "Name": "Kyrgyzstan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LA": {
                    "Name": "Lao People's Democratic Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LV": {
                    "Name": "Latvia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LB": {
                    "Name": "Lebanon",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LS": {
                    "Name": "Lesotho",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LR": {
                    "Name": "Liberia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LY": {
                    "Name": "Libyan Arab Jamahiriya",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LI": {
                    "Name": "Liechtenstein",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LT": {
                    "Name": "Lithuania",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LU": {
                    "Name": "Luxembourg",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MO": {
                    "Name": "Macao",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MK": {
                    "Name": "Macedonia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MG": {
                    "Name": "Madagascar",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MW": {
                    "Name": "Malawi",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MY": {
                    "Name": "Malaysia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MV": {
                    "Name": "Maldives",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ML": {
                    "Name": "Mali",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MT": {
                    "Name": "Malta",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MH": {
                    "Name": "Marshall Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MQ": {
                    "Name": "Martinique",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MR": {
                    "Name": "Mauritania",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MU": {
                    "Name": "Mauritius",
                    "Store": "https:\/\/moanabikini.com"
                },
                "YT": {
                    "Name": "Mayotte",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MX": {
                    "Name": "Mexico",
                    "Store": "https:\/\/moanabikini.com"
                },
                "FM": {
                    "Name": "Micronesia, Federated States Of",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MD": {
                    "Name": "Moldova",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MC": {
                    "Name": "Monaco",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MN": {
                    "Name": "Mongolia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ME": {
                    "Name": "Montenegro",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MS": {
                    "Name": "Montserrat",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MA": {
                    "Name": "Morocco",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MZ": {
                    "Name": "Mozambique",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MM": {
                    "Name": "Myanmar",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NA": {
                    "Name": "Namibia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NR": {
                    "Name": "Nauru",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NP": {
                    "Name": "Nepal",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NL": {
                    "Name": "Netherlands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AN": {
                    "Name": "Netherlands Antilles",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NC": {
                    "Name": "New Caledonia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NZ": {
                    "Name": "New Zealand",
                    "Store": "https:\/\/aus.moanabikini.com\/"
                },
                "NI": {
                    "Name": "Nicaragua",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NE": {
                    "Name": "Niger",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NG": {
                    "Name": "Nigeria",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NU": {
                    "Name": "Niue",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NF": {
                    "Name": "Norfolk Island",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MP": {
                    "Name": "Northern Mariana Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "NO": {
                    "Name": "Norway",
                    "Store": "https:\/\/moanabikini.com"
                },
                "OM": {
                    "Name": "Oman",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PK": {
                    "Name": "Pakistan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PW": {
                    "Name": "Palau",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PS": {
                    "Name": "Palestinian Territory, Occupied",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PA": {
                    "Name": "Panama",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PG": {
                    "Name": "Papua New Guinea",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PY": {
                    "Name": "Paraguay",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PE": {
                    "Name": "Peru",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PH": {
                    "Name": "Philippines",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PN": {
                    "Name": "Pitcairn",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PL": {
                    "Name": "Poland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PT": {
                    "Name": "Portugal",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PR": {
                    "Name": "Puerto Rico",
                    "Store": "https:\/\/moanabikini.com"
                },
                "QA": {
                    "Name": "Qatar",
                    "Store": "https:\/\/moanabikini.com"
                },
                "RE": {
                    "Name": "Reunion",
                    "Store": "https:\/\/moanabikini.com"
                },
                "RO": {
                    "Name": "Romania",
                    "Store": "https:\/\/moanabikini.com"
                },
                "RU": {
                    "Name": "Russian Federation",
                    "Store": "https:\/\/moanabikini.com"
                },
                "RW": {
                    "Name": "Rwanda",
                    "Store": "https:\/\/moanabikini.com"
                },
                "BL": {
                    "Name": "Saint Barthelemy",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SH": {
                    "Name": "Saint Helena",
                    "Store": "https:\/\/moanabikini.com"
                },
                "KN": {
                    "Name": "Saint Kitts And Nevis",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LC": {
                    "Name": "Saint Lucia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "MF": {
                    "Name": "Saint Martin",
                    "Store": "https:\/\/moanabikini.com"
                },
                "PM": {
                    "Name": "Saint Pierre And Miquelon",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VC": {
                    "Name": "Saint Vincent And Grenadines",
                    "Store": "https:\/\/moanabikini.com"
                },
                "WS": {
                    "Name": "Samoa",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SM": {
                    "Name": "San Marino",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ST": {
                    "Name": "Sao Tome And Principe",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SA": {
                    "Name": "Saudi Arabia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SN": {
                    "Name": "Senegal",
                    "Store": "https:\/\/moanabikini.com"
                },
                "RS": {
                    "Name": "Serbia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SC": {
                    "Name": "Seychelles",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SL": {
                    "Name": "Sierra Leone",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SG": {
                    "Name": "Singapore",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SK": {
                    "Name": "Slovakia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SI": {
                    "Name": "Slovenia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SB": {
                    "Name": "Solomon Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SO": {
                    "Name": "Somalia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ZA": {
                    "Name": "South Africa",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GS": {
                    "Name": "South Georgia And Sandwich Isl.",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ES": {
                    "Name": "Spain",
                    "Store": "https:\/\/moanabikini.com"
                },
                "LK": {
                    "Name": "Sri Lanka",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SD": {
                    "Name": "Sudan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SR": {
                    "Name": "Suriname",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SJ": {
                    "Name": "Svalbard And Jan Mayen",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SZ": {
                    "Name": "Swaziland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SE": {
                    "Name": "Sweden",
                    "Store": "https:\/\/moanabikini.com"
                },
                "CH": {
                    "Name": "Switzerland",
                    "Store": "https:\/\/moanabikini.com"
                },
                "SY": {
                    "Name": "Syrian Arab Republic",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TW": {
                    "Name": "Taiwan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TJ": {
                    "Name": "Tajikistan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TZ": {
                    "Name": "Tanzania",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TH": {
                    "Name": "Thailand",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TL": {
                    "Name": "Timor-Leste",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TG": {
                    "Name": "Togo",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TK": {
                    "Name": "Tokelau",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TO": {
                    "Name": "Tonga",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TT": {
                    "Name": "Trinidad And Tobago",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TN": {
                    "Name": "Tunisia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TR": {
                    "Name": "Turkey",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TM": {
                    "Name": "Turkmenistan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TC": {
                    "Name": "Turks And Caicos Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "TV": {
                    "Name": "Tuvalu",
                    "Store": "https:\/\/moanabikini.com"
                },
                "UG": {
                    "Name": "Uganda",
                    "Store": "https:\/\/moanabikini.com"
                },
                "UA": {
                    "Name": "Ukraine",
                    "Store": "https:\/\/moanabikini.com"
                },
                "AE": {
                    "Name": "United Arab Emirates",
                    "Store": "https:\/\/moanabikini.com"
                },
                "GB": {
                    "Name": "United Kingdom",
                    "Store": "https:\/\/moanabikini.com"
                },
                "US": {
                    "Name": "United States",
                    "Store": "https:\/\/moanabikini.com"
                },
                "UM": {
                    "Name": "United States Outlying Islands",
                    "Store": "https:\/\/moanabikini.com"
                },
                "UY": {
                    "Name": "Uruguay",
                    "Store": "https:\/\/moanabikini.com"
                },
                "UZ": {
                    "Name": "Uzbekistan",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VU": {
                    "Name": "Vanuatu",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VE": {
                    "Name": "Venezuela",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VN": {
                    "Name": "Viet Nam",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VG": {
                    "Name": "Virgin Islands, British",
                    "Store": "https:\/\/moanabikini.com"
                },
                "VI": {
                    "Name": "Virgin Islands, U.S.",
                    "Store": "https:\/\/moanabikini.com"
                },
                "WF": {
                    "Name": "Wallis And Futuna",
                    "Store": "https:\/\/moanabikini.com"
                },
                "EH": {
                    "Name": "Western Sahara",
                    "Store": "https:\/\/moanabikini.com"
                },
                "YE": {
                    "Name": "Yemen",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ZM": {
                    "Name": "Zambia",
                    "Store": "https:\/\/moanabikini.com"
                },
                "ZW": {
                    "Name": "Zimbabwe",
                    "Store": "https:\/\/moanabikini.com"
                }
            }

            var countryCode = data.country_code;
            var store;

            if (typeof stores[countryCode] === 'undefined') {
                store = 'https://moanabikini.com/';
            }
            else {
                store = stores[countryCode]['Store'];
            }

            $.cookie('slCCodes', JSON.stringify({'Country': stores[countryCode]['Name'], 'Code': countryCode, 'Store': store}))
            $.cookie('slUserIP', (data.ip==''?'-':data.ip));
            checkStoreRedirect();
        });

    } else {

        checkStoreRedirect();

    }
}

function getCountry() {
    if ($.cookie('slCCodes')) {
        return JSON.parse($.cookie('slCCodes'));
    }
}

function getUserIP() {
    if ($.cookie('slUserIP')) {
        return $.cookie('slUserIP');
    }
    return '';
}

function getParameterByName(name, url) {
    if (!url) {
        url = window.top.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}


var rdr = getParameterByName('rdr'), stopRedirection=false;

if (rdr) {
    $.cookie('dontRedirect', 1);
}

function updateStoreSelector() {

    if (ignoreStoreSelector) {
        return;
    }

    var storeSelectorSpans = $('#storeSelector .countryCode')
    var storeSelectorUrl = $('#storeSelectorUrl');
    var href=''+window.top.location;

    if (checkStoreRedirect()) {
        return;
    }

    var details = getCountry(), userIP = getUserIP();

    if (typeof details === 'undefined') {
        // if at this point `details` remains undefined, its due to the AJAX request to the geo server not yet being complete
        // sooooo, run this function again in a second and hope it's there if not rinse and repeat.
        setTimeout(updateStoreSelector, 1000)

        return;
    }

    storeSelectorSpans.each(function() {
        $(this).html(details.Country);
    });

    if (details.Store == 'https://moanabikini.com/') {
        storeSelectorUrl.find('span').html('International');
        $('#storeSelector .countryCode.last').html('International');
    }
    storeSelectorUrl.attr('href', details.Store);

}

function checkStoreRedirect()
{
    var href=''+window.top.location;
    var details = getCountry(), userIP = getUserIP();

    href=href.toLowerCase();
    stopRedirection=(href.indexOf('.myshopify.com/admin/themes/')>=0 || href.indexOf('?stopgeo=1')>=0 || href.indexOf('&stopgeo=1')>=0);
    if (!stopRedirection && userIP!='' && (userIP=='{{ settings.redirect_ip_exempt1 }}' || userIP=='{{ settings.redirect_ip_exempt2 }}' || userIP=='{{ settings.redirect_ip_exempt3 }}')) {
        stopRedirection=true;
    }

    if (typeof details === 'undefined') {
        return false;
    }

    if (!$.cookie('dontRedirect') && !stopRedirection && (details.Store != window.top.location.origin)) {
        window.top.location = details.Store;
        ignoreStoreSelector=true;
        return;
    }

    return false;
}
